import React                             from 'react';
import { thruHolePlacements as tooltip } from 'pu-data/Tooltips';
import TextComponent                     from './TextComponent';

const ThruHolePlacements = (props) => {
  const name = 'thru_hole';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="Thru-Hole<br />Placements"
      name={name}
      inputId={props.inputId}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={tooltip}
      groupName={props.groupName}
      inputClassName={props.inputClassName}
      errorMessage={props.errorMessage} />
  );
};

ThruHolePlacements.defaultProps = {
  inputId: 'thru-hole-placement',
};

export default ThruHolePlacements;
